function getTabContent(tab) {
    const tabId = tab.getAttribute('data-for');

    if (tabId) {
        return document.querySelector(`[data-tabs-accordion-content="${tabId}"]`);
    }

    return null;
}

function activateTab(tab) {
    tab.classList.add('horizontalAccordion__tab--active');

    const tabContent = getTabContent(tab);

    if (tabContent) {
        tabContent.classList.add('horizontalAccordion__content--active');
    }
}

function deactivateTab(tab) {
    tab.classList.remove('horizontalAccordion__tab--active');

    const tabContent = getTabContent(tab);

    if (tabContent) {
        tabContent.classList.remove('horizontalAccordion__content--active');
    }
}

function handleClick(tab, tabs) {
    activateTab(tab);
    tabs.filter(t => t !== tab).forEach(deactivateTab);
}

function initAccordion(accordion) {
    const tabs = [...accordion.querySelectorAll('.js_horizontalAccordion__tab')];

    tabs.forEach(tab => tab.addEventListener('click', e => handleClick(tab, tabs)));
}

function init() {
    $(document).ready(() => {
        const accordions = [...document.querySelectorAll('.js_horizontalAccordion')];
        accordions.forEach(initAccordion);
    });
}

module.exports = init;
